var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('v-banner',{staticClass:"white--text",attrs:{"color":"red","single-line":"","sticky":""}},[_c('prismic-rich-text',{staticClass:"emergency_banner",attrs:{"field":_vm.text}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }